import { useTranslation } from 'react-i18next'

import CircleCheck from '@/presentation/assets/svg/CircleCheck'
import CircleInfo from '@/presentation/assets/svg/CircleInfo'
import APROVATION_ITEM_STATUS from '@/services/constants/AprovationItemStatus'

interface AprovationStatusItemProps {
  status: string
}

const getColorTag = (status: string): JSX.Element => {
  const { t } = useTranslation()

  switch (status) {
    case APROVATION_ITEM_STATUS.PENDING:
      return (
        <span className="mb-6 flex w-full items-center gap-1 text-left text-sm text-primary">
          <CircleInfo width={16} height={16} color={'#0170B3'} />

          {t('PENDING_APPROVAL', 'Aprovação pendente')}
        </span>
      )

    case APROVATION_ITEM_STATUS.APPROVED:
      return (
        <span className="mb-6 flex w-full items-center gap-1 text-left text-sm text-success">
          <CircleCheck width={16} height={16} color={'#059669'} />

          {t('CHANGE_APPROVED', 'Alteração aprovada')}
        </span>
      )

    case APROVATION_ITEM_STATUS.PARTIALLY_APPROVED:
      return (
        <span className="mb-6 flex w-full items-center gap-1 text-left text-sm text-[#eab308]">
          <CircleInfo width={16} height={16} color={'#eab308'} />

          {t('PARTIALLY_APPROVED', 'Parcialmente aprovada')}
        </span>
      )

    case APROVATION_ITEM_STATUS.REJECTED:
      return (
        <span className="mb-6 flex w-full items-center gap-1 text-left text-sm text-[#ef4444]">
          <CircleInfo width={16} height={16} color={'#ef4444'} />

          {t('APPROVAL_REJECTED', 'Aprovação rejeitada')}
        </span>
      )

    default:
      return <></>
  }
}

const AlterationStatusItem = ({
  status
}: AprovationStatusItemProps): JSX.Element => {
  return <>{getColorTag(status)}</>
}

export default AlterationStatusItem
